import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import settingService from "api/settingsService";
import classNames from "classnames";
import Spinner from "components/Spinner";
import { ISpaceUsageReponse } from "dto/Settings/ISpaceUsageResponse";
import prettyBytes from "pretty-bytes";
import { useAuth } from "react-oidc-context";
import { getUserId } from "utils/getUserId";
import SecondCheckbox from "components/SecondCheckbox";
import Button from "components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
export interface IFileToDownload {
  Id: string;
  FileName: string;
  Path: string;
  Size: number;
  IsEncrypted: boolean;
  Type: string;
}

export interface IDownloadedFile {
  Uri: string;
  FileName: string;
  ContentType: string;
  Url: string;
  KeyId: any;
  KeyPk: any;
  ObjectKey: string;
  ParentKey: string;
  CaseKeyId: any;
  Bucket: string;
}

const DiskTab: FC<Props> = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  getUserId(auth.user!);
  const { data: spaceUsageResponse, isSuccess: isSpaceUsageLoaded } =
    settingService.useGetSpaceUsage();

  const [spaceUsage, setSpaceUsage] = useState<ISpaceUsageReponse | null>(null);

  useEffect(() => {
    if (isSpaceUsageLoaded) {
      setSpaceUsage(spaceUsageResponse.data);
    }
  }, [spaceUsageResponse]);

  const [c, setC] = useState(false);
  const [showCases, setShowCases] = useState(false);

  const Download = () => {
    return (
      <>
        <div className={styles.group}>
          <div className={styles.title}>{t("diskTab.downloadYourData")}</div>
          <div className={styles.hint}>
            {t("diskTab.exportAllDataHint")}
          </div>

          <div className={styles.checkboxes}>
            <SecondCheckbox
              onChange={() => setC(false)}
              value={!c}
              text={t("diskTab.metadataLayout")}
            />
            <SecondCheckbox
              onChange={() => setC(true)}
              value={c}
              text={t("diskTab.casesLayout")}
            />
          </div>
          <div className={styles.buttonWrapper}>
            <Button
              className={styles.button}
              text={t("diskTab.exportData")}
              onClick={() => {
                window.open(
                  `${import.meta.env.VITE_APP_SITE}/export`,
                  "_blank"
                );
              }}
            />
          </div>
        </div>
      </>
    );
  };

  if (!spaceUsage) {
    return <Spinner></Spinner>;
  }

  return (
    <div className={styles.wrapperr}>
      <Download />
      <div className={styles.wrapper}>
        <div className={styles.group}>
          <div className={styles.title}>{t("diskTab.diskUsage")}</div>
          {/* <div className={styles.hint}>
          Kontroluj zajętość swojej przestrzeni na przesyłki i plik w NotaUp
        </div> */}
          <div className={styles.total}>
            <div className={styles.row}>
              <div className={styles.percent}>
                {t("settings.available")}{" "}
                {(
                  ((spaceUsage?.Total - spaceUsage?.Used) / spaceUsage.Total) *
                  100
                ).toFixed(1)}
                %
              </div>
              <div>
                {t("diskTab.usedOfTotal", {
                  used: prettyBytes(spaceUsage.Used, { binary: true }),
                  total: prettyBytes(spaceUsage.Total, { binary: true }),
                })}
              </div>
            </div>
            <div className={classNames(styles.bar, styles.big)}>
              <div
                className={styles.used}
                style={{
                  width: (spaceUsage.Used / spaceUsage.Total) * 100 + "%",
                }}
              ></div>
            </div>
          </div>
        </div>
        {showCases && (
          <div className={styles.cases}>
            <div className={styles.caseRow}>
              <div className={styles.col1}>
                <div className={styles.data}>
                  <div className={styles.title}>{t("diskTab.filesUsage")}</div>
                </div>
                <div className={styles.usedLabel}>
                  {prettyBytes(spaceUsage.FilesSize ?? 0, { binary: true })}
                </div>
              </div>
              <div className={styles.col}>
                <div className={classNames(styles.bar)}>
                  <div
                    className={styles.used}
                    style={{
                      width:
                        ((spaceUsage.FilesSize ?? 0) / spaceUsage.Total) * 100 +
                        "%",
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div className={styles.caseRow}>
              <div className={styles.col1}>
                <div className={styles.data}>
                  <div className={styles.title}>
                    {t("diskTab.databaseUsage")}
                  </div>
                </div>
                <div className={styles.usedLabel}>
                  {prettyBytes(spaceUsage.DbSize ?? 0, { binary: true })}
                </div>
              </div>
              <div className={styles.col}>
                <div className={classNames(styles.bar)}>
                  <div
                    className={styles.used}
                    style={{
                      width:
                        ((spaceUsage.DbSize ?? 0) / spaceUsage.Total) * 100 + "%",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div onClick={() => setShowCases(!showCases)} className={styles.btn2}>
          {!showCases ? <>{t("diskTab.checkDetails")}</> : <>{t("settings.hideDetails")}</>}{" "}
          <FontAwesomeIcon icon={!showCases ? faCaretDown : faCaretUp} />
        </div>
      </div>
    </div>
  );
};

export default DiskTab;
